import { render, staticRenderFns } from "./instagramButton.vue?vue&type=template&id=e82455b6&scoped=true&"
import script from "./instagramButton.vue?vue&type=script&lang=js&"
export * from "./instagramButton.vue?vue&type=script&lang=js&"
import style0 from "./instagramButton.vue?vue&type=style&index=0&id=e82455b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82455b6",
  null
  
)

export default component.exports